import { render } from "./WebContainerPluzzView.vue?vue&type=template&id=c98527b6&scoped=true"
import script from "./WebContainerPluzzView.vue?vue&type=script&lang=js"
export * from "./WebContainerPluzzView.vue?vue&type=script&lang=js"

import "./WebContainerPluzzView.vue?vue&type=style&index=0&id=c98527b6&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c98527b6"]])

export default __exports__